import React, { useState } from 'react';
import Tooltip from '../ToolTip';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const ToggleSwitch = ({
  label,
  id,
  name,
  onChange,
  value,
  checked,
  error,
  helperText,
  classes
}: IToggleSwitch) => {
  const [checkedValue, setCheckedValue] = useState<boolean>(checked);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <div className="w-fit flex items-center gap-2">
      <label className="flex cursor-pointer select-none items-center">
        <div className="relative">
          <input
            type="checkbox"
            name={name}
            id={id}
            value={value}
            checked={checkedValue}
            onChange={() => {
              setCheckedValue(!checkedValue);
              onChange(!checkedValue);
            }}
            className="sr-only"
          />
          <div
            className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none  focus:ring-offset-2 ${
              checkedValue ? 'bg-primary-main' : 'bg-gray-200'
            }`}></div>
          <div
            className={`absolute pointer-events-none left-1 top-0.5 inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
              checkedValue ? 'translate-x-4' : ''
            }`}></div>
        </div>
      </label>
      <Tooltip message={label}>
        <QuestionMarkCircleIcon className="h-4 w-4 dark:text-darkBg-mainText" />
      </Tooltip>
    </div>
  );
};

export default ToggleSwitch;

interface IToggleSwitch {
  label: string;
  id?: string;
  name: string;
  value?: string;
  selectedValue?: string;
  checked: boolean;
  onChange: (data: boolean) => void;
  error?: string;
  helperText?: string;
  classes?: string;
}
